__webpack_require__.p = "/assets/turbo/8077df58/quellede/_next/";